module.exports = __webpack_public_path__ + "static/media/dashboardpage-browsefreelancerscard-avatar-3.6ac0deb8.webp";